export default {
  // 操作欄
  addAssign: '添加賦碼',
  // 搜索區
  batchNo: '碼批次',
  batchNoPlaceholder: '請輸入碼批次',
  codeSn: '二維碼',
  codeSnPlaceholder: '請輸入二維碼',
  productName: '產品名稱',
  productNamePlaceholder: '請輸入產品名稱',
  productSn: '產品編號',
  productSnPlaceholder: '請輸入產品編號',
  productionBatch: '生產批次',
  productionBatchPlaceholder: '請輸入生產批次',
  // 表格列
  colProductInfo: '產品資訊',
  colProductionBatch: '生產批次',
  colBatchNo: '碼批次',
  colQrcodeRange: '二維碼區間',
  colCount: '數量',
  colRemark: '備註',
  colCreatedAt: '添加時間',
  colOperator: '操作人',
  colAction: '操作',
  // 產品資訊
  productNo: '產品編號',
  // 生產批次
  batchId: 'ID',
  // 操作
  delete: '刪除',
  // 添加賦碼彈窗
  addAssignTitle: '添加產品賦碼',
  batchNoLabel: '碼批次',
  selectBatch: '選擇',
  rangeType: '區間範圍',
  rangeTypeAll: '整批關聯',
  rangeTypeRange: '區間關聯',
  assignType: '賦碼方式',
  assignTypeProduct: '按產品',
  assignTypeProductionBatch: '按生產批次',
  startQrcode: '開始二維碼',
  endQrcode: '結束二維碼',
  relatedProduct: '關聯產品',
  selectProduct: '選擇產品',
  remarkLabel: '備註',
  remarkPlaceholder: '請輸入備註',
  batchNoRequired: '請選擇碼批次',
  productRequired: '請選擇關聯產品',
  startQrcodeRequired: '請輸入開始二維碼',
  endQrcodeRequired: '請輸入結束二維碼',
  // 刪除確認
  deleteConfirmTitle: '確認刪除',
  deleteConfirmContent: '確定要刪除該條賦碼記錄嗎？',
  // 空狀態
  emptyText: '暫無賦碼記錄',
};
